module.exports = __webpack_public_path__ + "static/WEDDING E&M-607-dcf5118927fb3c3eb375bfa8e28152a0.jpg";